import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import { REGISTER_USER } from "../../constants/actionTypes";
import {
  registerUserSuccessful,
  registerUserFailed,
} from "../../actions/authentication";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../helpers/firebase_helper";
import { signupUser } from "../../api/user";
import { finalizePromotionSeller } from "../../api/buyerSellerOnboarding";
import { clearPublicStoreSetupResume } from "../../helpers/publicStoreSetupResume";

// initialize relavant method of both Auth
const fireBaseBackend = getFirebaseBackend();

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user } }) {
  try {
    const currentUser = fireBaseBackend.getAuthenticatedUser();
    const isCurrentUserAnonymous = currentUser && currentUser.isAnonymous;

    // Build the payload for the backend signup endpoint
    const signupPayload = {
      email: user.email,
      password: user.password,
      locationId: user.locationId || null,
      role: user.role || null,
    };

    // Anonymous conversion — send the existing anonymous uid
    if (
      user.isPublic &&
      isCurrentUserAnonymous &&
      user.email &&
      user.password
    ) {
      console.log("Converting anonymous user to permanent account");
      signupPayload.uid = currentUser.uid;
    }

    const response = user.promotionCode
      ? yield call(finalizePromotionSeller, {
          promotionCode: user.promotionCode,
          storeId: user.storeId,
          uid: currentUser?.uid,
          email: user.email,
          password: user.password,
          displayName: user.displayName || null,
          phone: user.number || null,
        })
      : yield call(signupUser, signupPayload);

    if (response?.data?.status >= 400 || response?.data?.error) {
      throw new Error(
        response?.data?.message || "Signup failed"
      );
    }

    const { customToken } = response.data;

    // Sign in on the frontend using the custom token returned by the backend
    const authUser = yield call(
      fireBaseBackend.loginUser,
      null,
      null,
      customToken
    );

    // Registration complete — update Redux state
    yield put(registerUserSuccessful(authUser));
    clearPublicStoreSetupResume();

    window.location.href = "/dashboard";
    window.location.reload();
  } catch (error) {
    console.error("Registration error:", error);

    // Extract a user-friendly message from the API response or error
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Registration failed. Please try again.";

    // Check if we're dealing with an anonymous user
    const currentUser = fireBaseBackend.getAuthenticatedUser();
    const isAnonymousFlow = currentUser && currentUser.isAnonymous;

    // Only log out if this is NOT an anonymous user flow
    // For anonymous users, we want to keep them logged in even if registration fails
    if (!isAnonymousFlow) {
      yield call(fireBaseBackend.logout);
    }

    yield put(registerUserFailed(message));
  }
}

export function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser);
}

function* accountSaga() {
  yield all([fork(watchUserRegister)]);
}

export default accountSaga;
